import { render, staticRenderFns } from "./OrganizationListScreen.vue?vue&type=template&id=4aaf9b78&"
import script from "./OrganizationListScreen.vue?vue&type=script&lang=ts&"
export * from "./OrganizationListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports